<template>
  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">Çarkıfelek Raporları</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <router-link tag="li" to="/" class="breadcrumb-item"
                ><a>Anasayfa</a></router-link
              >
              <li class="breadcrumb-item active">Çarkıfelek Raporları</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>
    <!-- /.content-header -->

    <!-- Main content -->
    <div class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header card-title">Çarkıfelek Raporları</div>
              <div class="card-body">
                <div class="overlay-wrapper">
                  <div class="overlay" v-if="overlay">
                    <i class="fas fa-3x fa-spinner fa-spin"></i>
                  </div>
                  <div class="row">
                    <div class="col">
                      <input
                        type="text"
                        placeholder="Müşteri ID"
                        class="form-control form-control-sm"
                        v-model="search.code"
                      />
                    </div>
                    <div class="col">
                      <input
                        type="text"
                        placeholder="Transaction ID"
                        class="form-control form-control-sm"
                        v-model="search.transaction"
                      />
                    </div>
                    <div class="col">
                      <button class="btn btn-info btn-sm" @click="pagination">
                        <i class="fas fa-search"></i> Filtrele
                      </button>
                      <button class="btn btn-danger btn-sm" @click="reset">
                        <i class="fas fa-trash"></i>
                      </button>
                    </div>
                  </div>
                  <hr />
                  <table class="table table-striped projects">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Müşteri ID</th>
                        <th>Tarih</th>
                        <th>Durum</th>
                        <th>Transaction ID</th>
                        <th>İşlem Adı</th>
                        <th>Bonus</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(data, index) in datas" :key="index">
                        <td>{{ ++index }}</td>
                        <td>{{ data.code }}</td>

                        <td>{{ data.date | DateFormat }}</td>
                        <td>{{ data.status ? "Kazandı" : "Kaybetti" }}</td>
                        <td>{{ data.transaction }}</td>
                        <td>{{ data.name }}</td>
                        <td>{{ data.bonus }}</td>
                      </tr>
                      <tr>
                        <td
                          v-if="datas.length == 0"
                          colspan="7"
                          class="text-center"
                        >
                          Kayıt Bulunamadı
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="card-footer">
                <pagination
                  v-model="page"
                  :records="rows"
                  :per-page="count"
                  @paginate="pagination"
                />
              </div>
            </div>

            <!-- /.card -->
          </div>
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>
    <!-- /.content -->
  </div>
  <!-- /.content-wrapper -->
</template>
<script>
export default {
  data() {
    return {
      page: 1,
      count: 10,
      rows: 0,
      overlay: false,
      datas: [],
      again: 0,
      agains: [],
      search: {
        code: "",
        transaction: "",
      },
    };
  },
  methods: {
    pagination(value) {
      this.getDatas();
      this.getDatas(true);
    },
    reset() {
      this.page = 1;
      this.search = {
        code: "",
        transaction: "",
      };
      this.getDatas();
      this.getDatas(true);
    },
    getDatas(type = false) {
      this.overlay = true;
      this.$http
        .post("Passionflower/ListRequest", {
          code: this.search.code,
          transaction: this.search.transaction,
          rowNumber: type,
          page: this.page - 1,
        })
        .then((response) => {
          if (type) this.rows = response.data;
          else this.datas = response.data;

          this.overlay = false;
        });
    },
  },
  filters: {
    DateFormat(value) {
      if (!value) return "Belirtilmemiş";

      let date = value.split("T")[0].split("-");
      let time = value.split("T")[1].split(".")[0];
      return date[2] + "/" + date[1] + "/" + date[0] + " " + time;
    },
  },
  created() {
    this.getDatas();
    this.getDatas(true);
  },
  watch: {
    "$store.getters.getSite"() {
      this.getDatas();
      this.getDatas(true);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Report/PassionFlowerReport.vue